<button mat-icon-button *ngFor="let ratingId of ratingArr; index as i"
        [ngStyle]="{'color':'#FBBC04'}"
        [id]="'star_'+i"
        (click)="onClick(i+1)"
        [matTooltip]="(ratingId+1).toString()"
        matTooltipPosition="above">
  <mat-icon>
    {{showIcon(i)}}
  </mat-icon>
</button>
<mat-error *ngIf="starCount == null || starCount == 0" i18n>Please select rating</mat-error>